import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox, PrismRadioGroup } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import {
  ELIGIBILITY_QUESTION_TYPES,
  type EligibilityQuestionType,
} from 'lumen/utils/constants/otb-selfservice-constants';

interface SettingsMyotbEligibilityQuestionSignature {
  Args: {
    answers: string[];
    name: string;
    options: string[];
    questionType: EligibilityQuestionType;
    setAnswers: (name: string, answers: string[]) => void;
  };
}

export default class SettingsMyotbEligibilityQuestion extends Component<SettingsMyotbEligibilityQuestionSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get firstAnswer() {
    return this.args.answers[0];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get options() {
    return this.args.options.map((option) => ({
      name: option,
      isSelected: this.args.answers.includes(option),
    }));
  }

  @action onChangeValue(event: Event): void {
    const answers = [...this.args.answers];

    const typedTarget = event.target as HTMLInputElement;

    if (this.args.questionType === ELIGIBILITY_QUESTION_TYPES.SINGLE) {
      answers[0] = typedTarget.value;
    } else if (this.args.questionType === ELIGIBILITY_QUESTION_TYPES.MULTIPLE) {
      if (!answers.includes(typedTarget.value)) {
        answers.push(typedTarget.value);
      } else {
        const index = answers.indexOf(typedTarget.value);
        answers.splice(index, 1);
      }
    }

    this.args.setAnswers(this.args.name, answers);
  }

  <template>
    <div class="flex flex-col gap-400">
      <h3 class="line-clamp-2">{{t @name}}</h3>

      {{#if (eq @questionType ELIGIBILITY_QUESTION_TYPES.SINGLE)}}
        <PrismRadioGroup
          @name="eligibility-question-radio-group"
          @onChange={{this.onChangeValue}}
          @value={{this.firstAnswer}}
          as |RadioGroup|
        >
          <div class="flex flex-col gap-200">
            {{#each this.options as |option|}}
              <RadioGroup.input @value={{option.name}}>
                {{t option.name}}
              </RadioGroup.input>
            {{/each}}
          </div>
        </PrismRadioGroup>
      {{else if (eq @questionType ELIGIBILITY_QUESTION_TYPES.MULTIPLE)}}
        <div class="flex flex-col gap-200">
          {{#each this.options as |option|}}
            <PrismCheckbox
              @checked={{option.isSelected}}
              @onChange={{this.onChangeValue}}
              @value={{option.name}}
            >
              {{t option.name}}
            </PrismCheckbox>
          {{/each}}
        </div>
      {{/if}}
    </div>
  </template>
}
